module.exports = __webpack_public_path__ + "img/step-5.1c7cb810.png";